import { Component, Input } from '@angular/core';
import { environment } from '@ups/xplat/core';

@Component({
  selector: 'ups-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone: false,
})
export class LayoutComponent {
  // TODO: Configure with the menu service
  @Input()
  menuItems: {
    title: string;
    url: string;
  }[] = [
    {
      title: 'Help',
      url: '/home',
    },
    {
      title: 'Logout',
      url: '',
    },
  ];

  environment = environment;

  constructor() {}
}
